/* Scout Coffee. Ported from the mockup's runtime: the hash router and the
   base64 de-duplication are gone, the behaviour that is part of the design is not. */
(function(){
  var hdr = document.querySelector('header');
  if (!hdr) return;

  /* the fixed bar changes height when the nav wraps, so pages measure it */
  function measureHeader(){
    document.documentElement.style.setProperty(
      '--hdr', Math.round(hdr.getBoundingClientRect().height) + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);

  /* mobile menu */
  var burger = hdr.querySelector('.burger');
  var navEl  = document.getElementById('sitenav');
  function closeMenu(){
    hdr.classList.remove('nav-open');
    if (burger) burger.setAttribute('aria-expanded','false');
    if (navEl) navEl.querySelectorAll('li.has.open').forEach(function(l){ l.classList.remove('open'); });
  }
  if (burger){
    burger.addEventListener('click', function(){
      var open = hdr.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) closeMenu();
      measureHeader();
    });
  }
  if (navEl){
    navEl.querySelectorAll('li.has > a').forEach(function(a){
      a.addEventListener('click', function(e){
        if (window.matchMedia('(max-width:880px)').matches){
          var li = a.parentNode;
          if (!li.classList.contains('open')){ e.preventDefault(); li.classList.add('open'); }
        }
      });
    });
    navEl.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a');
      if (a && !a.parentNode.classList.contains('has')) closeMenu();
    });
  }
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeMenu(); });
  document.addEventListener('click', function(e){
    if (hdr.classList.contains('nav-open') && !hdr.contains(e.target)) closeMenu();
  });

  /* the bar is transparent only while a full-bleed hero is behind it */
  var hero = document.querySelector('main .hero, main .phero');
  if (!hero){
    hdr.classList.remove('over');
  } else {
    hdr.classList.add('over');
    var bar = hdr.querySelector('.bar');
    var h = bar ? bar.getBoundingClientRect().height : 66;
    new IntersectionObserver(function(e){
      hdr.classList.toggle('over', e[0].isIntersecting);
    }, {rootMargin: '-' + Math.round(h) + 'px 0px 0px 0px', threshold: 0}).observe(hero);
  }

  /* home hero slideshow */
  var slides = [].slice.call(document.querySelectorAll('.hero .slide'));
  var dots   = [].slice.call(document.querySelectorAll('.dots button'));
  if (slides.length > 1){
    var i = 0, timer = null, DELAY = 6500;
    function go(n){
      i = (n + slides.length) % slides.length;
      slides.forEach(function(s,k){ s.classList.toggle('is-on', k === i); });
      dots.forEach(function(d,k){ d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function stop(){ if (timer){ clearInterval(timer); timer = null; } }
    function start(){ stop(); timer = setInterval(function(){ go(i+1); }, DELAY); }
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); start(); }); });
    var heroEl = document.querySelector('.hero');
    heroEl.addEventListener('mouseenter', stop);
    heroEl.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : start(); });
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  /* shop category filter: tiles glide into their new position (FLIP) rather
     than jumping, and cards newly revealed fade+scale in. Cards leaving are
     hidden immediately so the remaining grid can reflow to be measured. */
  var filterNav  = document.querySelector('[data-filter-nav]');
  var filterGrid = document.querySelector('[data-filter-grid]');
  if (filterNav && filterGrid){
    var cards = [].slice.call(filterGrid.children);
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function applyFilter(cat){
      var first = new Map();
      var wasVisible = new Map();
      cards.forEach(function(c){
        wasVisible.set(c, !c.hidden);
        if (!reduceMotion && !c.hidden) first.set(c, c.getBoundingClientRect());
      });

      cards.forEach(function(c){
        var match = cat === 'all' || c.dataset.cat === cat;
        c.classList.remove('enter','enter-in');
        c.style.transition = 'none';
        c.style.transitionDelay = '';
        c.style.transform = '';
        c.hidden = !match;
      });

      if (reduceMotion) return;

      /* forced reflow (not a second rAF) between setting the inverted state
         and enabling the transition: Safari sometimes coalesces two nested
         rAF style writes into one paint, so the "before" position never
         actually commits and nothing appears to move. */
      cards.forEach(function(c, i){
        if (c.hidden) return;
        if (wasVisible.get(c) && first.has(c)){
          var last = c.getBoundingClientRect();
          var f = first.get(c);
          var dx = f.left - last.left;
          var dy = f.top - last.top;
          if (Math.abs(dx) > 1 || Math.abs(dy) > 1){
            c.style.transition = 'none';
            c.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
            void c.offsetWidth;
            c.style.transition = 'transform .46s cubic-bezier(.22,.68,0,1)';
            c.style.transform = '';
          }
        } else if (!wasVisible.get(c)){
          c.classList.add('enter');
          void c.offsetWidth;
          c.style.transitionDelay = Math.min(i * 14, 140) + 'ms';
          c.classList.add('enter-in');
          c.classList.remove('enter');
        }
      });
    }

    filterNav.addEventListener('click', function(e){
      var a = e.target.closest('a[data-filter]');
      if (!a) return;
      e.preventDefault();
      if (a.getAttribute('aria-pressed') === 'true') return;
      filterNav.querySelectorAll('a').forEach(function(x){
        x.setAttribute('aria-pressed', x === a ? 'true' : 'false');
      });
      applyFilter(a.dataset.filter);
    });
  }

  /* sizes="auto" picks the real laid-out width. Where it is not supported the
     attribute is invalid and the browser falls back to 100vw, so measure instead. */
  var supportsAuto = 'sizes' in HTMLImageElement.prototype &&
    (function(){ var t = document.createElement('img'); t.sizes = 'auto'; return t.sizes === 'auto'; })();
  if (!supportsAuto){
    document.querySelectorAll('img[sizes="auto"]').forEach(function(img){
      if (img.complete) return;
      var w = Math.ceil(img.getBoundingClientRect().width);
      if (w > 0) img.sizes = w + 'px';
    });
  }
})();
